import { useTranslation } from "react-i18next";
import { KitProductModel } from "../../../Api/Models/product.model";
import { TickFilledIcon } from "../../../Components/Icons/TickFilledIcon";
import { LongArrowRightIcon } from "../../../Components/Icons/LongArrowRightIcon";
import DotBreadcrumbs from "../../../Components/DotBreadcrumbs";
import { useState, useEffect } from "react";

export const ExchangeIcon: React.FunctionComponent<{}> = () => {
    return (
        <svg
            fill="none"
            stroke="currentColor"
            strokeWidth={1.5}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            width="20px"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
            />
        </svg>
    );
};

interface ProductWithSizesProps {
    kitProduct: KitProductModel;
    setKitProductVariation: CallableFunction;
    handleBack?: CallableFunction;
    skipProduct: CallableFunction;
    skipAll: CallableFunction;
    back: CallableFunction | null;
    currentStep: number;
    totalSteps: number;
    kitToAssignProducts: KitProductModel[];
}

const ProductWithSizes: React.FunctionComponent<ProductWithSizesProps> = ({
                                                                              kitProduct,
                                                                              setKitProductVariation,
                                                                              handleBack,
                                                                              skipProduct,
                                                                              skipAll,
                                                                              back,
                                                                              currentStep,
                                                                              totalSteps,
                                                                              kitToAssignProducts,
                                                                          }) => {
    const { t } = useTranslation();

    const [selectedVariationId, setSelectedVariationId] = useState<number | null>(null);

    useEffect(() => {
        const previousSelection = kitToAssignProducts.find((p) => p.id === kitProduct.id)?.selectedVariationId;
        if (previousSelection) {
            setSelectedVariationId(previousSelection);
        }
    }, [kitProduct, kitToAssignProducts]);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (selectedVariationId) {
            setKitProductVariation(kitProduct.id, selectedVariationId);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="flex justify-center mt-6">
                <div className="stock-item__image" style={{ position: "static", margin: "0", transform: "none" }}>
                    <img src={kitProduct.image} alt={kitProduct.name} width="70px" />
                </div>
            </div>

            <div className="stock-item__title heading text-center mb-2 mt-4">
                {kitProduct.quantity > 1 ? `${kitProduct.quantity} x ` : null}
                {kitProduct.name}
            </div>

            <div className="text-secondary text-center mb-6">
                {t("Select the Rider’s size, if it’s not available you can skip it and come back later")}
            </div>

            {handleBack && (
                <div className="flex justify-center">
                    <div className="kit-product-group-exchange mt-4" onClick={() => handleBack()}>
                        <span className="mr-3">{t("Select another product")}</span>
                        <ExchangeIcon />
                    </div>
                </div>
            )}

            <div className={`grid gap-3 mt-4 mb-4 grid-cols-${Math.min(kitProduct.variations.length, 4)}`}>
                {kitProduct.variations.map((variation) => (
                    <label key={variation.id} className={`choice-card ${!variation.stockEnough ? "disabled" : ""}`}>
                        <input
                            type="radio"
                            id={`radio-variation-${variation.id}`}
                            name="variation"
                            value={variation.id}
                            checked={selectedVariationId === variation.id}
                            onChange={(e) => {
                                setSelectedVariationId(+e.target.value);
                            }}
                            disabled={!variation.stockEnough}
                            required
                        />
                        <div className="choice-card__content">
                            {variation.name}
                            <div className="choice-card__marker">
                                <TickFilledIcon />
                            </div>
                        </div>
                    </label>
                ))}
            </div>

            {!handleBack && (
                <div className="mt-8 mb-8">
                    <DotBreadcrumbs currentStep={currentStep} totalSteps={totalSteps} />
                </div>
            )}

            <div className="flex gap-4 mb-4 mt-8">
                <div className="flex-1">
                    {back ? (
                        <button type="button" className="button button--light" onClick={() => back()}>
                            {t("Back")}
                        </button>
                    ) : (
                        <button type="button" className="button" onClick={() => skipAll()}>
                            {t("Skip all")}
                        </button>
                    )}
                </div>
                <div className="flex-1">
                    <button type="button" className="button button--light" onClick={() => skipProduct(kitProduct.id)}>
                        {t("Skip")}
                    </button>
                </div>
            </div>

            <div className="pb-4">
                <button type="submit" className="button">
                    {t("Next")} <LongArrowRightIcon />
                </button>
            </div>
        </form>
    );
};

export default ProductWithSizes;
